import * as React from 'react';
import styled, { css } from 'styled-components';
import { colors } from '../colors/color';

type FancyRadioButtonProps = {
    id:string,
    name:string, // radio group
    value:string,
    checked?:boolean,
    checkedStyle: 'failure' | 'success' | 'neutral',
    disabled?:boolean,
    style?: React.CSSProperties,
    onChange:(value:string)=>void
}
export function FancyRadioButton(props:React.PropsWithChildren<FancyRadioButtonProps>):JSX.Element
{
    let selectionColor = colors.fancyRadioButton.selectedColor.neutral;
    if(props.checkedStyle === 'failure'){
        selectionColor = colors.fancyRadioButton.selectedColor.failure;
    } 
    else if(props.checkedStyle === 'success'){
        selectionColor = colors.fancyRadioButton.selectedColor.success;
    }

    return (
        <div style={props.style}>
            <RadioInput
                type="radio"
                id={props.id}
                name={props.name} 
                value={props.value} 
                checked={props.checked} 
                disabled={props.disabled}
                onChange={() => props.onChange(props.value)} />
            
            <RadioLabel htmlFor={props.id} selectionColor={selectionColor} checked={props.checked ?? false} disabled={props.disabled ?? false}>
                {props.children}
            </RadioLabel>
        </div>
    );
}

const RadioInput = styled.input`
    opacity: 0;
    position: fixed;
    width: 0;

    &:focus-visible + label {
        border: 1px solid ${colors.fancyRadioButton.borderFocus};
    }
`;

const RadioLabel = styled.label<{selectionColor:string, checked:boolean, disabled:boolean}>`
    display: flex;
    gap:4px;
    height:100%;
    justify-content: space-around;
    align-items: center;
    padding: 10px 20px;
    font-family: sans-serif, Arial;
    font-size: 14px;
    white-space: nowrap;
    border-radius: 4px; // outline follows the border radius
    border: 1px solid ${colors.fancyRadioButton.border};
    

    background-color: ${colors.fancyRadioButton.background};

    &:hover {
        ${props => !props.disabled && css`
            cursor: pointer;
            outline: 2px solid ${props.selectionColor};
            background-color: ${colors.fancyRadioButton.backgroundSelected};

            svg {
                fill: ${props.selectionColor};
            }
        `}
    }

    ${props => props.checked && css`
        outline: 2px solid ${props.selectionColor};
        background-color: ${colors.fancyRadioButton.backgroundSelected};

        svg {
            fill: ${props.selectionColor};
        }
    `}

    ${props => props.disabled && css`
        background-color: ${colors.fancyRadioButton.backgroundDisabled};
    `}

`;